import React, { useState } from 'react'
import styled from 'styled-components'
import { Link, useParams } from "react-router-dom";
import axios from 'axios';
import ErrorPopup from "../components/ErrorPopup";
import SuccessPopup from '../components/SuccessPopup';
import Blob from '../assets/blob-hero.svg';

function BankDetails() {

    document.title = "Add Bank Details | Lehumo";

    const { id } = useParams();

    const [accNumber, setAccNumber] = useState("");
    const [bankName, setBankName] = useState("");
    const [accType, setAccType] = useState("");

    //Error Popup
    const [errorPopup, setErrorPopup] = useState(false);
    const [successPopup, setSuccessPopup] = useState(false);

    const handleSubmit = (event) => {
        event.preventDefault();

        axios.post('http://localhost:5000/addbank', {
            user_id: id,
            bank_name: bankName,
            account_number: accNumber,
            account_type: accType
        })
            .then((response) => {
                setSuccessPopup(true);
            })
            .catch((error) => {
                console.log(error);
                setErrorPopup(true);
            });
    };

    return (
        <>
            <Container>
                <ErrorPopup trigger={errorPopup} setTrigger={setErrorPopup}>
                    <h3><span>☠️</span><br></br>Something went wrong</h3>
                    <p>Please try again</p>
                    <center>
                        <button onClick={() => setErrorPopup(false)}>Close</button>
                    </center>
                </ErrorPopup>

                <SuccessPopup trigger={successPopup} setTrigger={setSuccessPopup}>
                    <h3><span>👍</span><br></br>Bank details added</h3>
                    <center>
                        <Link to={`/ThankYou`}><button>Continue</button></Link>
                    </center>
                </SuccessPopup>

                <FormContainer>
                    <center>
                        <form onSubmit={handleSubmit}>
                            <h3>Add Bank Details</h3>
                            <select name="bank_name" className='bank_name' onChange={(event) => setBankName(event.target.value)}>
                                <option>Bank name</option>
                                <option>ABSA</option>
                                <option>African Bank</option>
                                <option>Capitec Bank</option>
                                <option>First National Bank</option>
                                <option>Standard Bank</option>
                                <option>Nedbank</option>
                                <option>Tymbank</option>
                                <option>Bidvest Bank</option>
                            </select><br />
                            <input type="number" name="account_number" minLength="5" placeholder="Account number" required onChange={(event) => setAccNumber(event.target.value)} />
                            <select name="account_type" onChange={(event) => setAccType(event.target.value)}>
                                <option>Account Type</option>
                                <option>Cheque</option>
                                <option>Savings</option>
                            </select><br />
                            <button type="submit" name="submit">Add Bank Account</button>
                        </form>

                    </center>
                </FormContainer>
            </Container>
        </>
    )
}

export default BankDetails

const Container = styled.div`
    background-image: linear-gradient(rgba(255, 246, 246, 0.2),rgba(255, 246, 246, 0.2)),url(${Blob});
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    height: auto;
    display: flex;
    justify-content: center;
    align-item: center;

    
    @media (max-width: 900px) {
        background: var(--background);

    }
`

const FormContainer = styled.div`
    background: var(--background);
    width: 70%;
    height: 350px;
    margin: 100px auto;
    border-radius: 10px;
    justify-content: center;
    align-item: center;
    font-family: 'Poppins', sans-serif;
    box-shadow: rgba(99, 99, 99, 0.5) 0px 2px 8px 0px;

    form {
        padding-top: 30px;
    }

    input {
        border: 2px solid var(--primary);
        background: transparent;
        border-radius: 4px;
        width: 300px;
        height: 50px;
        margin-bottom: 10px;
        padding-left: 10px;
        padding-right: 10px;
        outline: none;
        justify-content: space-between;
        margin-left: 2.5px;

        @media (max-width: 900px) {
            width: 300px;
        }
    }

    select {
        border: 2px solid var(--primary);
        background: transparent;
        border-radius: 4px;
        width: 300px;
        height: 50px;
        margin-bottom: 10px;
        padding-left: 10px;
        padding-right: 10px;
        outline: none;
        justify-content: space-between;
        margin-left: 2.5px;

        @media (max-width: 900px) {
            width: 300px;
        }
    }

       button {
        width: 600px;
        height: 50px;
        border-radius: 4px;
        background-color: var(--primary);
        border: 2px solid var(--primary);
        color: #fff;
        text-transform: uppercase;
        margin-top: 5px;
        font-weight: 600;
        font-size: 14px;

        :hover {
            background-color: transparent;
            border-radius: 30px;
            border: 2px solid var(--primary);
            color: var(--primary);
            transition: 0.2s ease-in-out;
        }

        @media (max-width: 900px) {
            width: 300px;
        }
    }

    p {
        margin-top: 30px;
        margin-bottom: 10px;
        font-size: 12px;
        font-weight: bold;
    }

    h3 {
        margin-top: 30px;
        margin-bottom: 20px;
        font-size: 18px;
        font-weight: bold;
        text-align: center;

        @media (max-width: 900px) {
            text-align: center;
            margin-left: 0px;
        }
    }

    span {
        font-size: 11px;
        text-align: justify;
    }


    .bank_name {
        width: 600px;

        @media (max-width: 900px) {
            width: 300px;
        }
    }

    
    @media (max-width: 900px) {
        background: transparent;
        width: 95%;
        height: 400px;
        border: none;
        box-shadow: none;
    
    }

`
